import { CATEGORY_STATISTICS, CATEGORY_MARKETING } from '../config/constants';

const updateGoogleConsentMode = (categories) => {
    if (typeof window.gtag !== 'function') {
        return;
    }

    const hasStatistics = categories.includes(CATEGORY_STATISTICS);
    const hasMarketing = categories.includes(CATEGORY_MARKETING);

    window.gtag('consent', 'update', {
        'analytics_storage': hasStatistics ? 'granted' : 'denied',
        'ad_storage': hasMarketing ? 'granted' : 'denied',
        'ad_user_data': hasMarketing ? 'granted' : 'denied',
        'ad_personalization': hasMarketing ? 'granted' : 'denied',
    });
};

export default updateGoogleConsentMode;
